// https://github.com/winstonjs/winston#creating-custom-formats
// https://stackoverflow.com/questions/56090851/winston-logging-object
import { format } from "winston";

const sanitizeString = (str: string, sanitizingRegExes: RegExp[]) => {
	let result = str;
	sanitizingRegExes.forEach((regex) => {
		result = result.replace(regex, "[REDACTED]");
	});
	return result;
};

const formatSingleMessage = (message: any, sanitizingRegExes: RegExp[] = []) =>
	typeof message === "object"
		? sanitizeString(JSON.stringify(message, null, 3), sanitizingRegExes)
		: sanitizeString(String(message), sanitizingRegExes);

/**
 * Formats a winston logger message. We want messages to be a single line of text. If a log statement
 * is sent with multiple messages separated by commas, then that's how they will appear in the log file.
 * But, we want objects to be exploded into JSON.
 *
 * This function is recursive to one level. An initial array is interpreted as log("blah", "foo", "wow").
 * Therefore, log("blah", ["foo", "woo"]) would display as "foo, ["foo","woo"]"
 */
const formatMessage = (messages: any, isArgs: boolean = true, sanitizingRegExes: RegExp[] = []): any => {
	if (Array.isArray(messages)) {
		return messages
			.map((message) =>
				isArgs ? formatMessage(message, false, sanitizingRegExes) : formatSingleMessage(message, sanitizingRegExes)
			)
			.join(",");
	} else {
		return formatSingleMessage(messages, sanitizingRegExes);
	}
};

export default (sanitizingRegExes: RegExp[]) =>
	format.combine(
		format.timestamp(),
		format.printf(
			(info) => `[${info.timestamp}] [${info.level}]: ${formatMessage(info.message, true, sanitizingRegExes)}`
		)
	);
